var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EditButton',{staticClass:"edit-button",on:{"click":function($event){return _vm.$emit('edit', _vm.item)}}}),_vm._v(" "),_c('DeleteButton',{staticClass:"delete-button",on:{"click":function($event){return _vm.$emit('delete', _vm.item)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c5c5ad3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/EditDeleteButtons.vue
// module id = null
// module chunks = 